// Web module: connections (lane L2). Entity: connection.
//   /connections       ConnectionsPage: Active / Available tabs, health summary, Microsoft app status, missing
//                      providers, Operational status filter, a health card per connection (Test connection, Sync now)
//   /connections/:id   generic detail page plus a Health tab (card with every dependent test, sync runs)
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    connection: {
      ListPage: lazyComponent(() => import('./ConnectionsPage'), 'ConnectionsPage'),
      detailTabs: [
        {
          id: 'health',
          label: 'Health',
          order: 15,
          component: lazyComponent(() => import('./HealthTab'), 'HealthTab'),
        },
      ],
    },
  },
}
